import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import configs from '../config/config';
import CartSection from './CartSection';
import SearchWidget from './SearchWidget';
import BottomBar from '../components/ecommerce/BottomBar'; 

import CategoriesNav from '../components/CategoriesNav';
import { useQuery } from '@tanstack/react-query'; 
import { useCart } from '../context/CartContext';
import { fetchNavbar } from '../libs/apis/NavigationBarApi';

import { fetchLayoutSettings } from '../libs/apis/LayoutSettingsApi';
// ─── SVG Icon Component ───────────────────────────────────────────────────────
const Icon = ({ name, size = 24, color = "currentColor" }) => {
  const attrs = { fill: "none", stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };
  const paths = {
    menu:     <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>,
    x:        <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    search:   <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    user:     <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    bag:      <><ShoppingCart/></>,
  };

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...attrs}>
      {paths[name] || null}
    </svg>
  );
};





// ─── Default config (fallback) ────────────────────────────────────────────────
const DEFAULT_CONFIG = {
  topBar: {
    visible: true,
    
   gradient: [configs.BASE_COLOR, '#cc0016'],
    leftMain: "We offer fast and reliable shipping",
    leftSub: "Mon–Sun, 9am–6pm",
    currencies: ["We deliver to:", "Nakuru", "Nairobi", "Mombasa"],
    

     /** gradient: ['#722f37', '#f44355'],
      
      leftMain: "Your favorite place for fine wines and spirits.",
      
      leftSub: "Open Daily • Chilled Delivery • Order Anytime",
    
      currencies: [
          "Now Delivering In:",
          "Nairobi",
          "Nakuru"
      ]**/
  
  },
  logo: {
    type: "image",
    text: "Junisa",
    fontSize: 24,
    fontWeight: "700",
    color: "#111827",
    imageUrl: "data:image/jpeg;base64,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",
    width: 120,
    height: 50,
  },
  search: {
    visible: true,
    placeholder: "Search products…",
    borderColor: "#d1d5db",
    borderRadius: 8,
    focusColor: "#2563eb",
    bgColor: "#f3f4f6",
    iconColor: "#6b7280",
    width: "300px",
  },
  menuItems: [
    { id: "home", label: "Home", href: "", position: "left", bold: false },
    { id: "shop", label: "Shop", href: "shop", position: "left", bold: false },
    { id: "help", label: "Help Center", href: "help-center", position: "left", bold: false },
    { id: "contact", label: "Contact", href: "contact", position: "right", bold: false },
  ],
  nav: {
    bg: "#ffffff",
    shadow: false,
    sticky: true,
    height: 64,
    borderBottom: true,
    borderColor: "#e5e7eb",
  },
  icons: { color: "#111827", size: 24 },
  cartBadgeColor: configs.BASE_COLOR,
  menuFontSize: 15,
  menuTextColor: "#111827",
  menuPosition: "left",
};

// Cache constants
const CACHE_KEY_NAVBAR = 'navbar_config_cache';
const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

// ─── Main Navigation Bar Component ────────────────────────────────────────────
const NavigationBar = ({ cartConfig, searchConfig, CatConfig, previewConfig = {}, previewMode = null }) => {
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const [active, setActive]   = useState(null);
  const [mobOpen, setMobOpen] = useState(false);
  const token = localStorage.getItem("token");
const debounceRef = useRef(null);
  //const [cfg, setCfg] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchShow,setSearchShow]=useState(false);
  const [user, setUser] = useState(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('userInfor');
    if (storedToken && storedUser && storedUser !== 'null') {
      try { return JSON.parse(storedUser); } catch { return null; }
    }
    return null;
  });
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [_cartCount, setCartCount] = useState(0);
  const [allCategories, setCategories] = useState([]);
  const [popularProducts, setFilteredProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredSuggestions, setSuggestions] = useState([]);
   
 const userButtonRef = useRef(null);
  const dropdownRef = useRef(null);
const [isTyping, setIsTyping] = useState(false);
const [activeTab,setActiveTab]=useState(null);
/* ─── Inject Quicksand font ─────────────────────────────────────────────────── */
const injectFont = () => {
  if (document.getElementById("qs-font")) return;
  const l = document.createElement("link");
  l.id = "qs-font";
  l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap";
  document.head.appendChild(l);
};



const SIMPLE_LINKS = ["Sale 🔥", "New In", "Brands"];





const checkIfReady = (value) => {
setLoading(true);
  setIsTyping(true); // user is typing

  if (value.length > 1) {

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(async () => {
      await handleSearch(value);
      setIsTyping(false); // typing stopped
      setSearchShow(true);
    }, 800);

  } else {
    setSearchShow(false);
    setIsTyping(false);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
  }
};
 

 

  // ── Stale-While-Revalidate Cache Logic for Navbar ─────────────────────────
  /**useEffect(() => {
    if (isPreview) {
      setCfg({ ...DEFAULT_CONFIG, ...previewConfig });
      setLoading(false);
      return;
    }

    const loadNavbar = async () => {
      // 1. Load cached data first (instant render)
      const cachedStr = localStorage.getItem(CACHE_KEY_NAVBAR);
      let hasStaleCache = false;
      let staleTs = 0;

      if (cachedStr) {
        try {
          const parsed = JSON.parse(cachedStr);
          const { data, ts } = parsed;
          staleTs = ts || 0;
          hasStaleCache = true;

          setCfg(prev => ({
            ...prev,
            ...data,
            topBar: { ...prev.topBar, ...data.topBar },
            logo: { ...prev.logo, ...data.logo },
            search: { ...prev.search, ...data.search },
            nav: { ...prev.nav, ...data.nav },
            icons: { ...prev.icons, ...data.icons },
            menuItems: data.menuItems?.map(i => ({ 
              ...i, 
              id: i.id || Math.random().toString(36).slice(2) 
            })) ?? prev.menuItems,
            menuPosition: data.menuPosition || "left",
          }));
        } catch (e) {
          console.warn("Invalid navbar cache");
          localStorage.removeItem(CACHE_KEY_NAVBAR);
        }
      }

      if (!token) {
        setLoading(false);
        return;
      }

      // 2. Check if cache needs refresh
      const isExpired = !hasStaleCache || Date.now() - staleTs >= CACHE_TTL;

      if (!isExpired) {
        setLoading(false);
        return;
      }

      // 3. Fetch fresh data in background
      setLoading(true);
      try {
        await axios.get(configs.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

        const slug = 'navbar';
        const isDup = slug && slug.includes('-');

        let res;
        if (isDup) {
          res = await axios.get(`${configs.API_URL}/api/customsettings/${slug}`, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          });
        } else {
          res = await axios.get(configs.API_URL + '/api/nav-config', {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          });
        }

        const dbData = isDup 
          ? (res.data.customSettings || {}) 
          : (res.data.navBarSettings || {});

        const freshConfig = {
          ...DEFAULT_CONFIG,
          ...dbData,
          topBar: { ...DEFAULT_CONFIG.topBar, ...dbData.topBar },
          logo: { ...DEFAULT_CONFIG.logo, ...dbData.logo },
          search: { ...DEFAULT_CONFIG.search, ...dbData.search },
          nav: { ...DEFAULT_CONFIG.nav, ...dbData.nav },
          icons: { ...DEFAULT_CONFIG.icons, ...dbData.icons },
          menuItems: dbData.menuItems?.map(i => ({ 
            ...i, 
            id: i.id || Math.random().toString(36).slice(2) 
          })) ?? DEFAULT_CONFIG.menuItems,
          menuPosition: dbData.menuPosition || "left",
        };

        setCfg(freshConfig);

        // Update cache with fresh data
        localStorage.setItem(CACHE_KEY_NAVBAR, JSON.stringify({
          data: freshConfig,
          ts: Date.now()
        }));

      } catch (err) {
        console.warn("Navbar API fetch failed - keeping cached data", err);
      } finally {
        setLoading(false);
      }
    };

    loadNavbar();
  }, [token, isPreview, previewConfig]);**/
 const isPreview = !!previewConfig;
let marginBottomDynamic='220px';
if(previewMode==="mobile" || window.innerWidth <= 768){
   marginBottomDynamic='60px';
}


 /** const {
    data: cfg = {},
    isLoading,
    error,
  } = useQuery({
    queryKey: ['navbar-t', token],
    queryFn: async () => {
    const result = await fetchNavbar();
    return result;
  },
    enabled: true, // don't fetch if preview mode
    //initialData: previewConfig || {}, // optional preview fallback
  });**/
const { data: layout = {}, isLoading, error } = useQuery({
  queryKey: ['layout', token],           
  queryFn: fetchLayoutSettings,          
  enabled: true,
  staleTime: 1000 * 60 * 60,             
  cacheTime: 1000 * 60 * 60 * 24,          
});
 const cfg=layout?.nav;
 let effectiveConfig = isPreview ? { ...DEFAULT_CONFIG, ...previewConfig } : cfg;
 

 // console.log('kenyaeffective',effectiveConfig);

  const isMobileView = previewMode === "mobile" || 
    (typeof window !== 'undefined' && window.innerWidth <= 768);

  // ── Fetch categories ───────────────────────────────────────────────────────
  const fetchAllProductsAndCategories = async () => {
    //if (isPreview) return;
    try {
      const [categoriesRes] = await Promise.all([
        axios.get(`${configs.API_URL}/api/categories_`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      ]);

      const categoriesArray = categoriesRes.data?.newCategories2 || 
                             categoriesRes.data?.data || [];
                        /**     localStorage.setItem("categoriesArray", categoriesRes.data?.newCategories2 || 
                             categoriesRes.data?.data || []);**/

                            //// console.log(localStorage.getItem("categoriesArray"));
      setCategories(['All', ...categoriesArray]);
    } catch (err) {
      //console.error("Failed to fetch categories:", err);
    }
  };

  useEffect(() => {
    effectiveConfig = cfg;
  }, [token, isPreview]);

  // ── Fetch user ─────────────────────────────────────────────────────────────
  const fetchUser = async () => {
    if (!token) return;
    try {
      const res = await axios.get(`${configs.API_URL}/api/pullusers/${token}`);
      if (res.data.status !== 0) {
        setUser(res.data.user);
       localStorage.setItem('userInfor', JSON.stringify(res.data.user));
      }
    } catch (error) {
     // console.error('Error fetching user:', error);
      //localStorage.removeItem('userInfor');
     // setUser(null);
    }
  };

  useEffect(() => {
   fetchUser();
   const interval = setInterval(fetchUser,60000);
    return () => clearInterval(interval);
  }, [token, isPreview]);

  // ── Cart count ─────────────────────────────────────────────────────────────
  useEffect(() => {
    setCartCount(cartItems.length);
  }, [cartItems]);

  // ── Computed values ────────────────────────────────────────────────────────
  const leftItems  = effectiveConfig?.menuItems?.filter(m => m.position === "left");
  const rightItems = effectiveConfig?.menuItems?.filter(m => m.position === "right");

  const isDark = ["#000","#0f","#11","#1e"].some(p => effectiveConfig?.nav?.bg?.startsWith(p));
  const textColor = effectiveConfig?.menuTextColor || (isDark ? "#fff" : "#374151");
  const iconColor = effectiveConfig?.icons?.color || "#111827";
  const cartBadgeBg = effectiveConfig?.cartBadgeColor || "#2563eb";




 // isLoggedIn derived from user state
const menu = {
//  browse: {
   // label: "Browse",
   // featured: { label: "Trending Now", tag: "🔥", items: ["New Arrivals", "Under €30", "Sale Items", "Staff Picks", "Sustainable"] },
    sections: [
      {
        title: "",
        /**cats: [
          { icon: "", name: "Baseball Caps",    count: "", bg: "#fff0f0" },
          { icon: "", name: "Bags",   count: "", bg: "#eff6ff" },
           { icon: "", name: "Belts",   count: "", bg: "#eff6ff" },
          { icon: "", name: "Caps",   count: "",  bg: "#fffbeb" },
          { icon: "", name: "Hats",  count: "",  bg: "#f5f3ff" },
           { icon: "", name: "Reflector Jackets",   count: "",  bg: "#fffbeb" },
            { icon: "", name: "Towels",   count: "",  bg: "#fffbeb" },
            { icon: "", name: "Christmas Decoration",  count: "",  bg: "#f5f3ff" },
        ],**/
         cats: [
          { icon: "", name: "Whisky",    count: "", bg: "#fff0f0" },
          { icon: "", name: "Tequila",   count: "", bg: "#eff6ff" },
           { icon: "", name: "Beer",   count: "", bg: "#eff6ff" },
          { icon: "", name: "Vodka",   count: "",  bg: "#fffbeb" },
          { icon: "", name: "Rum",  count: "",  bg: "#f5f3ff" },
           { icon: "", name: "Gin",   count: "",  bg: "#fffbeb" },
            { icon: "", name: "Cocktails",   count: "",  bg: "#fffbeb" }
        ],
      },
      
    ],
  //},

 
};

  const handleNavigate = (url) => {
    //if (isPreview) return;
    setUserDropdownOpen(false);
    if (url === 'shop' || url.trim().toLowerCase() === 'shop') navigate(`/${url}/all`);
    else if (url === 'MainPage_s' || url === 'home' || url.trim().toLowerCase() === 'home' || url.trim().toLowerCase() === '') { 
      setActive(true); 
      setActiveTab('Home'); 
      //alert(activeTab);
      //navigate(`/home`); 
     }
    else if (url === 'Orders') navigate(`/${url}`);
    else if (url === 'Authentication') {
      if (effectiveConfig?.user?.sessionKey === token) navigate(`/Orders`);
      else navigate(`/${url}`);
    } else if (url === 'contact-us' || url.trim().toLowerCase() === 'contact us' || url.trim().toLowerCase() === 'contact') navigate(`/Contact`);
    else if (url === 'Account') navigate(`/myAccount`);
    else if (url === 'Wishlist') navigate(`/Wishlist`);
    else if (url.trim().toLowerCase() === 'help-center' || url.trim().toLowerCase() === 'help center' || url.trim().toLowerCase() === 'help') navigate(`/Help`);
    else if (url.trim().toLowerCase() === 'our-stores' || url.trim().toLowerCase() === 'stores') navigate(`/Stores`);
    else navigate(`/home`);
  };

  const logout = () => {
    //if (isPreview) return;
    localStorage.removeItem('token');
    localStorage.removeItem('system_role');
    localStorage.removeItem('userInfor');
    setUser(null);
    setUserDropdownOpen(false);
    navigate('/home');
  };

  const handleSearch = (query) => {
   // //if (isPreview) return;
     setFilteredProducts([]);
     search(query);
    
   
  };

  const search = async (query) => {
    ////if (isPreview) return;
    try {

      setLoading(true);
      await axios.get(configs.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      const response = await axios.post(
        configs.API_URL + '/api/pull_products',
        { searchQuery: searchQuery, token: token },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      setLoading(false);
      setSearchShow(true);
     /** if (!searchShow && response.data.data.length>0) {
      setSearchShow(true);
    }**/
      setFilteredProducts(response.data.data || []);
      setSuggestions(response.data.suggestions || []);
    } catch (error) {
      console.error("Search error:", error);
      setLoading(false);
    }
  };


const CSS = `
  .snav-root *{box-sizing:border-box;margin:0;padding:0;}
  .snav-root{font-family:'Quicksand',sans-serif;position:relative;}

  .snav-bar{
    background:#fff;
    border-bottom:1px solid rgba(0,0,0,0.07);
    position:relative;z-index:200;
  }
  .snav-inner{
    max-width:1280px;margin:0 auto;
    display:flex;align-items:center;
    padding:0 28px;height:68px;gap:12px;
  }

  /* Logo */
  .snav-logo{
    font-size:24px;font-weight:700;letter-spacing:-1px;
    color:#1a1a2e;flex-shrink:0;cursor:pointer;
    display:flex;align-items:center;gap:2px;user-select:none;
  }
  .snav-logo-dot{color:#990012;}
  .snav-logo-badge{
    font-size:9px;font-weight:700;
    background:#990012;color:#fff;
    border-radius:5px;padding:2px 6px;
    margin-left:6px;letter-spacing:.8px;
    font-family:'Quicksand',sans-serif;
  }

  /* Nav links */
  .snav-links{
    display:flex;align-items:center;gap:2px;
    list-style:none;flex:1;justify-content:center;
  }
  .snav-link-btn{
    font-family:'Quicksand',sans-serif;
    display:flex;align-items:center;gap:5px;
    padding:8px 16px;border-radius:12px;
    font-size:14px;font-weight:600;
    color:#1a1a2e;background:transparent;
    border:none;cursor:pointer;
    transition:background .16s,color .16s;
    white-space:nowrap;
  }
  .snav-link-btn:hover,.snav-link-btn.active{
    background:#fff0f0;color:#990012;
  }
  .snav-chevron{transition:transform .22s cubic-bezier(.4,0,.2,1);flex-shrink:0;}
  .snav-chevron.open{transform:rotate(180deg);}
  .snav-sale-pill{
    font-size:10px;font-weight:700;
    background:#990012;color:#fff;
    border-radius:5px;padding:2px 6px;
    font-family:'Quicksand',sans-serif;
  }

  /* Actions */
  .snav-actions{display:flex;align-items:center;gap:6px;flex-shrink:0;}
  .snav-icon-btn{
    width:40px;height:40px;border-radius:12px;
    border:1px solid rgba(0,0,0,0.08);
    background:transparent;
    display:flex;align-items:center;justify-content:center;
    cursor:pointer;color:#1a1a2e;position:relative;
    transition:all .16s;
  }
  .snav-icon-btn:hover{background:#fff0f0;border-color:#990012;color:#990012;}
  .snav-badge{
    position:absolute;top:-5px;right:-5px;
    width:18px;height:18px;border-radius:50%;
    background:#990012;color:#fff;
    font-size:10px;font-weight:700;
    display:flex;align-items:center;justify-content:center;
    border:2px solid #fff;font-family:'Quicksand',sans-serif;
  }
  .snav-cta{
    font-family:'Quicksand',sans-serif;
    background:#1a1a2e;color:#fff;
    border:none;padding:10px 22px;border-radius:12px;
    font-size:13px;font-weight:700;cursor:pointer;
    transition:all .18s;white-space:nowrap;
  }
  .snav-cta:hover{background:#990012;transform:translateY(-1px);}

  /* Hamburger */
  .snav-ham{
    display:none;width:40px;height:40px;border-radius:12px;
    border:1px solid rgba(0,0,0,0.08);background:transparent;
    flex-direction:column;align-items:center;justify-content:center;
    gap:5px;cursor:pointer;transition:border-color .16s;
  }
  .snav-ham:hover{border-color:#990012;}
  .snav-ham span{
    width:18px;height:2px;background:#1a1a2e;
    border-radius:2px;transition:all .28s ease;display:block;
  }
  .snav-ham.open span:nth-child(1){transform:rotate(45deg) translate(5px,5px);}
  .snav-ham.open span:nth-child(2){opacity:0;transform:scaleX(0);}
  .snav-ham.open span:nth-child(3){transform:rotate(-45deg) translate(5px,-5px);}

  /* Overlay */
  .snav-overlay{
    position:fixed;inset:0;z-index:150;
    background:rgba(26,26,46,.3);
    backdrop-filter:blur(3px);
    opacity:0;pointer-events:none;
    transition:opacity .25s;
  }
  .snav-overlay.show{opacity:1;pointer-events:all;}

  /* Dropdown */
  .snav-dropdown{
    position:relative;
    
    transform:translateX(-50%) translateY(-12px);
    top:calc(100% + 10px);
    background:#fff;
    border:1px solid rgba(0,0,0,0.07);
    border-radius:22px;
    box-shadow:0 24px 64px rgba(0,0,0,0.13),0 4px 16px rgba(0,0,0,0.05);
    opacity:0;pointer-events:none;
    transition:opacity .22s cubic-bezier(.4,0,.2,1),transform .22s cubic-bezier(.4,0,.2,1);
    z-index:9999999999999999 !important;
    min-width:720px;overflow:hidden;
  }
  .snav-dropdown.open{
    opacity:1;pointer-events:all;
    transform:translateX(-50%) translateY(0);
  }

  /* Dropdown top bar */
  .snav-drop-head{
    display:flex;align-items:center;justify-content:space-between;
    padding:20px 26px 4px;
  }
  .snav-drop-title{
    font-size:11px;font-weight:700;color:#c0bfc8;
    letter-spacing:1.4px;text-transform:uppercase;
  }
  .snav-drop-viewall{
    font-family:'Quicksand',sans-serif;
    font-size:12px;font-weight:700;color:#990012;
    background:none;border:none;cursor:pointer;
    display:flex;align-items:center;gap:4px;
    padding:5px 10px;border-radius:8px;
    transition:background .14s;
  }
  .snav-drop-viewall:hover{background:#fff0f0;}

  /* Section rows */
  .snav-drop-body{padding:14px 26px 22px;}
  .snav-section{margin-bottom:18px;}
  .snav-section:last-child{margin-bottom:0;}
  .snav-section-label{
    font-size:10px;font-weight:700;color:#d0cfd8;
    letter-spacing:1.2px;text-transform:uppercase;
    margin-bottom:10px;padding-left:2px;
  }
  .snav-cat-grid{
    display:grid;
    grid-template-columns:repeat(4,1fr);
    gap:8px;
  }

  /* Category card */
  .snav-cat-card{
    display:flex;flex-direction:column;align-items:center;
    gap:9px;padding:16px 10px;border-radius:16px;
    background:#f9f8f6;
    border:1.5px solid transparent;
    cursor:pointer;transition:all .18s ease;
    text-decoration:none;
  }
  .snav-cat-card:hover{
    background:#fff;
    border-color:rgba(153,0,18,0.25);
    transform:translateY(-3px);
    box-shadow:0 8px 24px rgba(153,0,18,0.12);
  }
  .snav-cat-icon-wrap{
    width:50px;height:50px;border-radius:14px;
    display:flex;align-items:center;justify-content:center;
    font-size:26px;transition:transform .18s;
  }
  .snav-cat-card:hover .snav-cat-icon-wrap{transform:scale(1.1) rotate(-4deg);}
  .snav-cat-name{
    font-size:12px;font-weight:700;color:#1a1a2e;
    text-align:center;line-height:1.2;
  }
  .snav-cat-count{font-size:10px;color:#b0afc0;font-weight:600;}

  /* Featured tag strip */
  .snav-feat-strip{
    border-top:1px solid rgba(0,0,0,0.055);
    background:#fafaf7;
    padding:14px 26px;
    display:flex;align-items:center;gap:7px;flex-wrap:wrap;
  }
  .snav-feat-label{
    font-size:11px;font-weight:700;color:#b0afc0;
    white-space:nowrap;margin-right:2px;
  }
  .snav-feat-tag{
    font-family:'Quicksand',sans-serif;
    display:inline-flex;align-items:center;
    padding:6px 14px;border-radius:20px;
    background:#fff;border:1px solid rgba(0,0,0,0.08);
    font-size:12px;font-weight:600;color:#1a1a2e;
    cursor:pointer;transition:all .15s;white-space:nowrap;
  }
  .snav-feat-tag:hover{
    background:#990012;color:#fff;
    border-color:#990012;transform:translateY(-1px);
    box-shadow:0 4px 12px rgba(153,0,18,0.3);
  }

  /* Desktop search */
  .snav-search-desktop{
    display:flex;align-items:center;
    background:#f8f7f4;border-radius:12px;
    padding:9px 14px;gap:8px;flex:1;max-width:260px;
    border:1.5px solid transparent;transition:all .18s;
  }
  .snav-search-desktop:focus-within{
    border-color:#990012;background:#fff;
    box-shadow:0 0 0 4px rgba(153,0,18,0.08);
  }
  .snav-search-desktop input{
    flex:1;border:none;background:transparent;
    font-family:'Quicksand',sans-serif;font-size:13px;font-weight:500;
    color:#1a1a2e;outline:none;
  }
  .snav-search-desktop input::placeholder{color:#b0afc0;}

  /* Mobile menu */
  .snav-mob{
    position:fixed;top:68px;right:0;bottom:0;
    width:min(360px,100vw);
    background:#fff;z-index:190;
    overflow-y:auto;
    transform:translateX(100%);
    transition:transform .3s cubic-bezier(.4,0,.2,1);
    border-left:1px solid rgba(0,0,0,0.07);
  }
  .snav-mob.open{transform:translateX(0);}
  .snav-mob-inner{padding:20px 16px 40px;}
  .snav-mob-section{margin-bottom:24px;}
  .snav-mob-sec-title{
    font-size:10px;font-weight:700;color:#b0afc0;
    letter-spacing:1.2px;text-transform:uppercase;
    padding-bottom:10px;
    border-bottom:1px solid rgba(0,0,0,0.06);
    margin-bottom:12px;
  }
  .snav-mob-cat-grid{
    display:grid;grid-template-columns:repeat(3,1fr);gap:8px;
  }
  .snav-mob-cat{
    display:flex;flex-direction:column;align-items:center;gap:6px;
    padding:12px 6px;border-radius:14px;background:#f9f8f6;
    border:1.5px solid transparent;cursor:pointer;
    text-decoration:none;transition:all .15s;
  }
  .snav-mob-cat:hover,.snav-mob-cat:active{
    border-color:#990012;background:#fff0f0;
  }
  .snav-mob-cat-icon{font-size:24px;}
  .snav-mob-cat-name{font-size:11px;font-weight:700;color:#1a1a2e;text-align:center;}
  .snav-mob-links-list{display:flex;flex-direction:column;gap:6px;}
  .snav-mob-link{
    display:flex;align-items:center;justify-content:space-between;
    padding:13px 16px;border-radius:14px;
    background:#f9f8f6;font-size:14px;font-weight:700;
    color:#1a1a2e;border:1.5px solid transparent;
    cursor:pointer;transition:all .15s;
    font-family:'Quicksand',sans-serif;width:100%;text-align:left;
  }
  .snav-mob-link:hover{background:#fff0f0;color:#990012;border-color:rgba(153,0,18,0.2);}
  .snav-mob-search{
    display:flex;align-items:center;gap:8px;
    background:#f9f8f6;border-radius:14px;
    padding:11px 14px;margin-bottom:20px;
    border:1.5px solid transparent;transition:all .18s;
  }
  .snav-mob-search:focus-within{border-color:#990012;background:#fff;}
  .snav-mob-search-inp{
    flex:1;border:none;background:transparent;
    font-family:'Quicksand',sans-serif;font-size:14px;font-weight:500;
    color:#1a1a2e;outline:none;
  }
  .snav-mob-search-inp::placeholder{color:#b0afc0;}
  .snav-mob-cta{
    font-family:'Quicksand',sans-serif;
    width:100%;background:#1a1a2e;color:#fff;
    border:none;padding:14px;border-radius:14px;
    font-size:14px;font-weight:700;cursor:pointer;
    margin-top:8px;transition:background .18s;
  }
  .snav-mob-cta:hover{background:#990012;}

  /* Promo banner inside dropdown */
  .snav-promo{
    display:flex;align-items:center;gap:10px;
    background:linear-gradient(135deg,#1a1a2e 0%,#2d2d4e 100%);
    border-radius:14px;padding:14px 18px;margin-bottom:18px;
  }
  .snav-promo-icon{font-size:28px;}
  .snav-promo-text{flex:1;}
  .snav-promo-title{font-size:13px;font-weight:700;color:#fff;margin-bottom:2px;}
  .snav-promo-sub{font-size:11px;color:rgba(255,255,255,.55);font-weight:500;}
  .snav-promo-btn{
    font-family:'Quicksand',sans-serif;
    background:#990012;color:#fff;border:none;
    padding:7px 14px;border-radius:9px;
    font-size:12px;font-weight:700;cursor:pointer;
    white-space:nowrap;transition:opacity .15s;
  }
  .snav-promo-btn:hover{opacity:.88;}

  @media(max-width:960px){
    .snav-links{display:none;}
    .snav-search-desktop{display:none;}
    .snav-cta{display:none;}
    .snav-ham{display:flex;}
  }
  @media(max-width:480px){
    .snav-inner{padding:0 14px;height:60px;}
    .snav-mob{top:60px;}
    .snav-logo{font-size:20px;}
    .snav-mob-cat-grid{grid-template-columns:repeat(2,1fr);}
  }
`;

const IconArrow = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

const Dropdown = ({ menu, open }) => (
  <div  onMouseLeave={() => setActive(null)} className={`snav-dropdown${open ? " open" : ""} mt-[430px]`} style={{marginLeft:'-350px', zIndex:'9999999999999'}}>
    {/* Promo banner */}
    

    {/* Header */}
    <div className="snav-drop-head">
      <span className="snav-drop-title">All {menu.label} Categories</span>
      <button  onClick={(e) => {e.preventDefault(); navigate('/Shop/all')}} className="snav-drop-viewall">
        View all <IconArrow />
      </button>
      <button onClick={(e)=>setActive(null)}className="snav-promo-btn">Close</button>
    </div>

    {/* Category sections */}
    <div className="snav-drop-body">
      {menu.sections.map((sec) => (
        <div className="snav-section" key={sec.title}>
          <div className="snav-section-label">{sec.title}</div>
          <div className="snav-cat-grid">
            {sec.cats.map((cat) => (
              <a
                key={cat.name}
                className="snav-cat-card cursor-pointer"
                
                onClick={(e) => {e.preventDefault(); navigate('/Shop/'+cat.name.toLowerCase()); setActive(null);}}
              >
                
                <div className="snav-cat-name">{cat.name}</div>
               
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>

    {/* Featured strip */}
    <div className="snav-feat-strip">
       <button onClick={(e)=>navigate('/home')} className="snav-promo-btn w-full">Go to home</button>
    </div>
  </div>
);

  return (
    <>
      <header
     
 
        style={{
          position: isPreview ? "fixed" : (effectiveConfig?.nav?.sticky ? "fixed" : "fixed"),
          top: isPreview ? "auto" : (effectiveConfig?.nav?.sticky ? 0 : "auto"),
          zIndex: isPreview ? 40 : 40,
          width: "100%",
          marginBottom:marginBottomDynamic,
          background: effectiveConfig?.nav?.bg,
          borderBottom: effectiveConfig?.nav?.borderBottom
            ? `1px solid ${effectiveConfig?.nav?.borderColor || "transparent"}`
            : "none",
          transition: "all 0.3s ease",
          
        }}
      >
        {/* Top Bar */}
        {effectiveConfig?.topBar?.visible && (
          <div
            style={{
              padding: "6px 16px",
              background: `linear-gradient(to right, ${effectiveConfig?.topBar?.gradient[0]}, ${effectiveConfig?.topBar?.gradient[1]})`,
              color: "#fff",
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>✓ {effectiveConfig?.topBar?.leftMain}</span>
            <select
              style={{
                background: "transparent",
                border: "none",
                color: "inherit",
                fontSize: "inherit",
                cursor: "pointer",
              }}
            >
              {effectiveConfig?.topBar?.currencies.map((c, i) => (
                <option key={i} style={{ color: "#000" }}>
                  {c}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Main Nav Bar */}
        <div
          style={{
            height: effectiveConfig?.nav?.height,
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            maxWidth: 1400,
            margin: "0 auto",
          }}
        >
          {/* Logo */}
          <div style={{ flexShrink: 0 }} className="cursor-pointer" onClick={(e)=>navigate('/home')}>
            {effectiveConfig?.logo?.type === "image" && effectiveConfig?.logo?.imageUrl ? (
              <img
                src={configs.LOGO_URL}
                alt="Logo"
                style={{
                  marginTop:'-6px',
                  height: effectiveConfig?.logo?.height || 36,
                  width: effectiveConfig?.logo?.width,
                  objectFit: "contain",
                }}
              />
            ) : (
              <span
                style={{
                  fontSize: effectiveConfig?.logo?.fontSize * 0.8,
                  fontWeight: effectiveConfig?.logo?.fontWeight,
                  color: effectiveConfig?.logo?.color,
                  letterSpacing: "-0.5px",
                  whiteSpace: "nowrap",
                }}
              >
                {effectiveConfig?.logo?.text}
              </span>
            )}
          </div>

          {/* Desktop Menu + Search */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              flex: 1,
              justifyContent: "flex-end",
            }}
          >
            {/* Desktop Left items */}
            <nav
              style={{
                display: !isMobileView ? "flex" : "none",
                alignItems: "center",
                gap: 12,
                marginRight: "auto",
              }}
            >
              {leftItems?.map((item) => (
                <a
                  key={item.id}
                  onClick={() => handleNavigate(item.href)}
                   
                  className="cursor-pointer flex"
                  style={{
                    fontSize: effectiveConfig?.menuFontSize || 14,
                    fontWeight: item.bold ? 700 : 500,
                    color: textColor,
                    textDecoration: "none",
                    padding: "8px 12px",
                    borderRadius: 6,
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.05)")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  {item.label}
                  

                </a>

              ))}
              {active && (
               <Dropdown menu={menu} open={active}/>
               )
              }
            </nav>

            


            {/* Search (desktop) */}
            {effectiveConfig?.search?.visible && !isMobileView && (
             <div
  style={{
    display: "flex",
    alignItems: "center",
    background: effectiveConfig?.search?.bgColor,
    border: `1.5px solid ${effectiveConfig?.search?.borderColor}`,
    borderRadius: effectiveConfig?.search?.borderRadius,
    padding: "8px 12px",
    minWidth: 220,
    maxWidth: 360,
    flex: 1,
  }}
>
  <Icon name="search" width="16" height="16" size={16} color={effectiveConfig?.search?.iconColor} />

  <input
    type="text"
    value={searchQuery}
    onChange={(e) => {
      setSearchQuery(e.target.value);
      checkIfReady(e.target.value);
    }}
    placeholder={effectiveConfig?.search?.placeholder}
    style={{
      border: "none",
      outline: "none",
      background: "transparent",
      marginLeft: 8,
      flex: 1,
      fontSize: 14,
      color: "#1e293b",
    }}
  />

 
  {loading && (
    <span className="ml-2 w-5 h-5 border-2 border-t-transparent rounded-full animate-spin" style={{borderColor:'#990012', borderTopColor:'transparent'}}></span>
  )}
</div>
            )}

            {/* Right items (desktop) */}
            {!isMobileView && (
              <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
                {rightItems?.map(m => (
                  <a
                    key={m.id}
                    onClick={() => handleNavigate(m.href)}
                    className="cursor-pointer"
                    style={{
                      fontSize: effectiveConfig?.menuFontSize || 14,
                      fontWeight: m.bold ? 700 : 500,
                      color: textColor,
                      textDecoration: "none",
                      padding: "8px 12px",
                      borderRadius: 6,
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.05)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    {m.label}
                  </a>
                ))}
              </div>
            )}

            {/* Icons + mobile hamburger */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {/* User dropdown */}
              <div className="relative" ref={userButtonRef}>
                <button
                  onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 6 }}
                >
                  <Icon name="user" width="22" height="22" size={22} color={iconColor} />
                </button>

                {userDropdownOpen && (
                  <div
                    ref={dropdownRef}
                    style={{
                      position: "absolute",
                      right: 0,
                      top: "100%",
                      marginTop: 8,
                      background: "#fff",
                      borderRadius: 8,
                      boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                      minWidth: 180,
                      zIndex: 1001,
                      overflow: "hidden",
                    }}
                  >
                    {user ? (
                      <>
                        <div style={{ padding: "12px 16px", borderBottom: "1px solid #eee", fontWeight: 600 }}>
                          Hello {user?.name || 'User'}!
                        </div>
                        <button onClick={() => { navigate('/Orders'); setUserDropdownOpen(false); }} style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 16px", border: "none", background: "none", cursor: "pointer" }}>
                          Orders
                        </button>
                        <button onClick={() => { navigate('/Wishlist'); setUserDropdownOpen(false); }} style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 16px", border: "none", background: "none", cursor: "pointer" }}>
                          Wishlist
                        </button>
                        <button onClick={() => { navigate('/myAccount'); setUserDropdownOpen(false); }} style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 16px", border: "none", background: "none", cursor: "pointer" }}>
                          My Account
                        </button>
                        <button
                          onClick={logout}
                          style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 16px", color: "#e53e3e", borderTop: "1px solid #eee", border: "none", background: "none", cursor: "pointer" }}
                        >
                          Logout
                        </button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => { navigate('/Authentication'); setUserDropdownOpen(false); }} style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 16px", border: "none", background: "none", cursor: "pointer" }}>
                          Login
                        </button>
                        <button onClick={() => { navigate('/Authentication'); setUserDropdownOpen(false); }} style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 16px", border: "none", background: "none", cursor: "pointer" }}>
                          Register
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>

              <button
                onClick={() => setCartOpen(true)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 8,
                  borderRadius: 8,
                  position: "relative",
                }}
              >
                <Icon name="bag" size={22} color={iconColor} />
                <span
                  style={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    background: cartBadgeBg,
                    color: "#fff",
                    fontSize: 10,
                    fontWeight: 700,
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {_cartCount}
                </span>
              </button>

              {isMobileView && (
                <button
                  onClick={() => setMobileOpen(!mobileOpen)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: 8,
                    borderRadius: 8,
                  }}
                >
                  <Icon
                    name={mobileOpen ? "x" : "menu"}
                    size={16}
                    color={iconColor}
                  />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Mobile-only search bar */}
        {isMobileView && effectiveConfig?.search?.visible && ( 
  <div className="px-4 md:hidden">
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "6px 10px",
        background: effectiveConfig?.search?.bgColor,
        borderRadius: effectiveConfig?.search?.borderRadius,
        border: `1.5px solid ${effectiveConfig?.search?.borderColor}`,
        minWidth: 0
      }}
    >
      <Icon name="search" size={12} color={effectiveConfig?.search?.iconColor} />

      <input
        type="text"
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value);
          checkIfReady(e.target.value);
        }}
        placeholder={effectiveConfig?.search?.placeholder}
        style={{
          border: "none",
          outline: "none",
          background: "transparent",
          marginLeft: 8,
          flex: 1,
          fontSize: 14,
          color: "#1e293b",
        }}
      />

      {/* Spinner */}
      {loading && (
        <span className="w-4 h-4 border-2 border-t-transparent rounded-full animate-spin" style={{borderColor:'#990012', borderTopColor:'transparent'}}></span>
      )}
    </div>

                   {active==='home' && (
                    <Dropdown menu={menu} open={active === 'Home'} />
                    )}
                   
                   
  </div>
)}
        {/* Mobile Menu Dropdown */}
        {mobileOpen && isMobileView && (
          <div
            style={{
              background: effectiveConfig?.nav?.bg,
              borderTop: `1px solid ${effectiveConfig?.nav?.borderColor || "#e5e7eb"}`,
              padding: "12px 0",
            }}
          >
            {effectiveConfig?.menuItems?.map((item) => (
              <a
                key={item.id}
                onClick={() => { handleNavigate(item.href); setMobileOpen(false); }}
                style={{
                  display: "block",
                  padding: "12px 24px",
                  fontSize: effectiveConfig?.menuFontSize || 16,
                  fontWeight: item.bold ? 700 : 500,
                  color: textColor,
                  textDecoration: "none",
                }}
              >
                {item.label}

              </a>
            ))}
          </div>
        )}
         <CategoriesNav configz={CatConfig}/>
         
      </header>
<br/><br/><br/><br/><br/><br/>
      {/* Overlays & BottomBar – only shown in real mode */}
     
        <>
          <SearchWidget
            isOpen={searchShow}
            onClose={() => {setSearchShow(false); setSearchQuery('')}}
            config={searchConfig}
            allCategories={allCategories}
            popularProducts={popularProducts}
            allCategorieX={filteredSuggestions}
            loading={loading}
            search_Query={searchQuery}
          />
          <CartSection
            isOpen={cartOpen}
            onClose={() => setCartOpen(false)}
            config={cartConfig}
          />
         
          
          <BottomBar activeTab={activeTab} setActiveTab={setActiveTab}/>
         
          
          )}
        </>
      

    </>
  );
};

export default NavigationBar;